import * as c from "../../constants/announcements";

const initialState = {
  message: "",
  timestamp: null,
};

const announcements = (state = initialState, action) => {
  switch (action.type) {
    case c.ANNOUNCE_MESSAGE:
      return {
        ...state,
        message: action.payload,
        timestamp: Date.now(), // Helps trigger re-render even if message is the same
      };
    case c.CLEAR_ANNOUNCEMENT:
      return {
        ...state,
        message: "",
        timestamp: null,
      };
    default:
      return state;
  }
};

export default announcements;
